/* ESLint errors suppressed for #4185 */
/* eslint-disable css-modules/no-unused-class */
import cn from 'classnames';

import checkoutStyles from 'styles/components/checkout/caap/layout.scss';

export const Column = ({ children, isLast }) => {
  const classes = cn(
    {
      [checkoutStyles.column]: true,
      [checkoutStyles.last]: isLast
    }
  );

  return (
    <div className={classes}>{children}</div>
  );
};

export const Row = params => {
  const { children, desktopOnly, isVerticalForm, mobileOnly, extraClass, withPadding } = params;
  const testId = params['data-test-id'];
  const dataTestId = testId ? { 'data-test-id': testId } : {};
  const classes = cn(
    {
      [checkoutStyles.row]: true,
      [checkoutStyles.withPadding]: withPadding,
      [checkoutStyles.hideSmallScreen]: desktopOnly,
      [checkoutStyles.showOnlySmallScreen]: mobileOnly,
      [checkoutStyles.isVerticalForm]: isVerticalForm
    }
  );
  return (
    <div { ...dataTestId } className={`${classes} ${extraClass ? extraClass : ''}`}>{children}</div>
  );
};

export const RowSpan = params => {
  const { children, span, isLast, mobileSpan, desktopSpan } = params;
  const testId = params['data-test-id'];
  const dataTestId = testId ? { 'data-test-id': testId } : {};
  const classes = cn(
    {
      [checkoutStyles[`span${span}`]]: !!span,
      [checkoutStyles[`mobileSpan${mobileSpan}`]]: !!mobileSpan,
      [checkoutStyles[`desktopSpan${desktopSpan}`]]: !!desktopSpan,
      [checkoutStyles.last]: isLast
    }
  );
  return (
    <div { ...dataTestId } className={classes}>{children}</div>
  );
};
/* eslint-enable */
